import { buildBackendLoginUrl, currentReturnPath, fetchAuthSession, preferredUserLabel, type AuthSessionData } from '@aide/auth-client'
import { useEffect, useState } from 'react'

interface AuthSessionState {
  authenticated: boolean
  loading: boolean
  profile: AuthSessionData | null
  userLabel: string | null
}

export function useAuthLinks(nextPath?: string) {
  const targetPath = nextPath || currentReturnPath()
  return {
    loginHref: buildBackendLoginUrl('vhoop', targetPath),
    signupHref: buildBackendLoginUrl('vhoop', targetPath, window.location.origin, '/api', 'signup'),
  }
}

export function useAuthSession(): AuthSessionState {
  const [profile, setProfile] = useState<AuthSessionData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true

    async function load() {
      setLoading(true)
      try {
        const session = await fetchAuthSession()
        if (active) {
          setProfile(session?.authenticated ? session : null)
        }
      } catch {
        if (active) {
          setProfile(null)
        }
      } finally {
        if (active) {
          setLoading(false)
        }
      }
    }

    void load()
    return () => {
      active = false
    }
  }, [])

  return {
    authenticated: Boolean(profile?.authenticated),
    loading,
    profile,
    userLabel: preferredUserLabel(profile),
  }
}
